<script>
  import * as Accordion from "$lib/components/ui/accordion/index.js";

  let {
    title,
    subtitle,
    faqs,
  } = $props();
</script>

<section class="border-b border-[#3a3a4a]">
  <div class="max-w-3xl mx-auto px-4 py-16">
    <div class="text-center mb-12">
      <p class="text-[#888890] text-xs uppercase tracking-widest mb-3">── FAQ ──</p>
      <h2 class="text-2xl md:text-3xl font-bold text-[#e8e8ec] mb-4">
        {title}
      </h2>
      <p class="text-[#a0a0a8] text-sm">{subtitle}</p>
    </div>

    <Accordion.Root type="single" collapsible class="border border-[#3a3a4a]">
      {#each faqs as faq, i}
        <Accordion.Item
          value="item-{i}"
          class="border-b border-[#3a3a4a] bg-[#101018] px-5 data-[state=open]:border-[#a855f7] transition-colors"
        >
          <Accordion.Trigger
            class="text-left text-[#c8c8cc] hover:text-[#e8e8ec] py-4 text-sm font-medium hover:no-underline [&[data-state=open]]:text-[#a855f7]"
          >
            <span class="text-[#888890] mr-3 select-none">[{String(i + 1).padStart(2, '0')}]</span>{faq.question}
          </Accordion.Trigger>
          <Accordion.Content class="text-[#909098] text-sm pb-4 leading-relaxed pl-6">
            {faq.answer}
          </Accordion.Content>
        </Accordion.Item>
      {/each}
    </Accordion.Root>
  </div>
</section>
